// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.
export function applyExecutionStates(operations, executionStates, stateArray) {
    if (!stateArray)
        return;
    stateArray.forEach((stateEntry) => {
        executionStates.set(stateEntry.name, stateEntry);
        const op = operations.get(stateEntry.name);
        if (!op)
            return;
        op.isActive = stateEntry.isActive;
        op.status = stateEntry.status || op.status;
        op.runInThisIteration = stateEntry.runInThisIteration;
        op.logFileURLs = stateEntry.logFileURLs;
    });
}
export function setQueuedStates(queuedStates, stateArray) {
    queuedStates.clear();
    if (!stateArray)
        return;
    stateArray.forEach((stateEntry) => {
        queuedStates.set(stateEntry.name, stateEntry);
    });
}
export function setOperationsFromPayload(operations, operationArray) {
    operations.clear();
    operationArray.forEach((op) => operations.set(op.name, op));
}
export function patchOperationsFromPayload(operations, operationArray) {
    operationArray.forEach((op) => operations.set(op.name, op));
}
export function toLastExecutionResultsMap(lastExecutionResultsArray) {
    const result = new Map();
    if (!lastExecutionResultsArray)
        return result;
    lastExecutionResultsArray.forEach((entry) => {
        result.set(entry.name, entry);
    });
    return result;
}
//# sourceMappingURL=dashboardMutations.js.map